export default "__VITE_ASSET__BQA7wBx0__"